import { render, staticRenderFns } from "./ReservationCancellationRulesForm.vue?vue&type=template&id=126d433e&scoped=true"
import script from "./ReservationCancellationRulesForm.vue?vue&type=script&lang=js"
export * from "./ReservationCancellationRulesForm.vue?vue&type=script&lang=js"
import style0 from "./ReservationCancellationRulesForm.vue?vue&type=style&index=0&id=126d433e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d433e",
  null
  
)

export default component.exports